import {
    DropdownInput,
    MultiselectInput,
    TextInput,
    NumberInput,
    TimeRangeInput,
    ButtonInput,
} from '@splunk/dashboard-inputs';
import type { PresetMap } from '@splunk/dashboard-types';
import {
    withMinimumSize,
    withResizeHandles,
    withShowCornerRadiusEditor,
    withHideInViewMode,
    withSetTokens,
    withCustomUrl,
    withShowDrilldown,
    withResetTokens,
    withSwitchToTab,
    withUnsetTokens,
} from './utils';

[
    DropdownInput,
    MultiselectInput,
    TextInput,
    NumberInput,
    TimeRangeInput,
].forEach((Input) => {
    withShowCornerRadiusEditor(Input);
    withResizeHandles(Input, ['w', 'e']);
    withMinimumSize(Input, { height: 75 });
});

export default {
    inputs: {
        'input.dropdown': DropdownInput,
        'input.multiselect': MultiselectInput,
        'input.text': TextInput,
        'input.number': NumberInput,
        'input.timerange': withHideInViewMode(TimeRangeInput),
        'input.button': withSwitchToTab(
            withResetTokens(
                withUnsetTokens(
                    withCustomUrl(
                        withShowDrilldown(
                            withSetTokens(ButtonInput, ['static'])
                        )
                    )
                )
            )
        ),
    } as PresetMap['inputs'],
};
